<template>
    <section class="l-section l-section--main">
        <div class="l-container l-container--main l-container--horizontalPaddings">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <h1 class="a-title">Uzyskaj dostęp</h1>
                    <form
                        @submit.prevent="handleSubmit"
                        class="a-mobile"
                    >
                        <div class="l-row">
                            <div class="l-row__column">
                                <a-control
                                    class="o-deliveryAddress__request"
                                    label="NIP"
                                    v-model="company.vatin"
                                    placeholder="1234567890"
                                    id="control-vatin"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--3">
                                <a-button
                                    class="a-button a-button--secondary a-button--mobileFullWidth o-deliveryAddress__changeVatin"
                                    :is-processing="vatinStatus === 'checkingVatin'"
                                    @click="vatinCheck"
                                >
                                    Pobierz
                                    <a-icon
                                        class="a-button__icon"
                                        icon="Edit"
                                    />
                                </a-button>
                            </div>
                        </div>
                        <div class="l-row l-row--multiline">
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    label="Nazwa firmy"
                                    v-model="company.name"
                                    id="name"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Ulica"
                                    v-model="company.address"
                                    id="address"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Miasto"
                                    id="city"
                                    v-model="company.city"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Kod pocztowy"
                                    v-model="company.postcode"
                                    id="postcode"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <label for="postcode" class="a-label a-control__label">Skąd się o nas dowiedziałeś?</label>
                                <select
                                    id="control-InfoSources"
                                    name="control-InfoSources"
                                    class="a-select"
                                    v-model="selectedInfoSource"
                                    required
                                >
                                    <option value="">-- wybierz opcję --</option>
                                    <option
                                        v-for="infoSource in infoSources"
                                        v-bind:key="infoSource.id"
                                        :value="infoSource.id"
                                    >{{ infoSource.name }}</option>
                                </select>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <h3 class="a-title a-title--subtitle">Osoba kontaktowa</h3>
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Imię"
                                    v-model="contact.first_name"
                                    id="first_name"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Nazwisko"
                                    v-model="contact.last_name"
                                    id="last_name"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    type="mask"
                                    :mask="'+48#########'"
                                    label="Telefon"
                                    placeholder="np. +48987654321"
                                    v-model="contact.phone"
                                    id="control-contactPhone"
                                    ref="contactPhone"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Adres e-mail"
                                    v-model="contact.email"
                                    id="control-contactEmail"
                                    ref="contactEmail"
                                    :required="true"
                                />
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    v-for="(term, termIdx) in terms"
                                    v-bind:key="term.symbol"
                                    type="checkbox"
                                    class="a-control--hasPaddings"
                                    :id="`control-terms-${term.symbol}`"
                                    @input="termClick(termIdx)"
                                    :value="acceptedTerms[termIdx]"
                                    :ref="`terms-${term.symbol}`"
                                >
                                    <p v-html="term.description"></p>
                                </a-control>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-button
                                    type="submit"
                                    class="a-button a-button--primary a-button--fullwidth"
                                    :is-processing="registerStatus === 'checkingVatin'"
                                >
                                    Zarejestruj się
                                </a-button>
                                <o-notifications
                                    name="register"
                                    :is-static="true"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ref, reactive, computed, onMounted } from '@vue/composition-api'
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_API_KEY })

export default {
    setup(_, { root }) {
        // Terms
        const terms = reactive([
            {
                symbol: 'oswiadczenie',
                description: 'Oświadczam, że jestem upoważniony do podejmowania zobowiązań w imieniu firmy'
            }
        ])
        const acceptedTerms = reactive(new Array(terms.length).fill(false))
        const termClick = termIdx => acceptedTerms.splice(termIdx, 1, !acceptedTerms[termIdx])
        // handle vatin
        const vatinStatus = computed(() => root.$store.getters.customerStatus)
        const vatinCheck = () => {
            if(typeof company.vatin !== 'string') {
                throw new Error('vatin is not a string')
            }
            company.vatin = company.vatin.replace(/-|\s/g, '')
            if(/^[0-9]{10}$/.test(company.vatin)) {
                root.$store.dispatch('detailsByVatin', company.vatin).then(result => {
                    company.city = result.data.city
                    company.postcode = result.data.postcode
                    company.name = result.data.company_name
                    company.address = result.data.address
                }).catch(error => {
                    console.error(error)
                })
            } else {
                root.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wprowadzony numer jest nieprawidłowy!',
                    name: 'control-vatin'
                })
            }
        }
        // info sources
        const selectedInfoSource = ref('')
        const infoSources = computed(() => root.$store.getters.infoSources)
        function fetchInfoSources() {
            root.$store.dispatch('fetchInfoSources')
        }
        onMounted(fetchInfoSources)
        // register
        const company = reactive({
            vatin: '',
            name: '',
            address: '',
            city: '',
            postcode: ''
        })
        const contact = reactive({
            first_name: '',
            last_name: '',
            phone: '',
            email: ''
        })
        const registerStatus = ref(false)
        const handleSubmit = async () => {
            // terms validation
            if(!terms.every((term, idx) => {
                if(acceptedTerms[idx] !== true) {
                    root.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Musisz zaakceptowć warunki.',
                        limit: 0,
                        name: `control-terms-${term.symbol}`
                    })
                    return false
                }
                return true
            })) {
                return false
            }
            // submit
            await root.$recaptchaLoaded()
            const token = await root.$recaptcha('login')
            if(token) {
                const payload = reactive({
                    token,
                    company: { ...company },
                    contact: { ...contact },
                    others: { source_id: selectedInfoSource },
                    terms: terms.reduce((previousValue, currentValue, idx) => {
                        previousValue.push({
                            symbol: currentValue.symbol,
                            confirmed: acceptedTerms[idx] !== undefined && acceptedTerms[idx] !== false
                        })
                        return previousValue
                    }, [])
                })
                root.$store.dispatch('users/signup', payload).then(response => {
                    // TODO empty object
                    root.$store.dispatch('addNotification', {
                        type: 'success',
                        content: response.data.data.confirmation,
                        limit: 0,
                        name: 'register'
                    }).then(() => {
                        setTimeout(() => {
                            root.$router.push({ name: 'dashboard-login' })
                        }, 4000)
                    })
                }).catch(error => {
                    root.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: error.response.data.message,
                        limit: 0,
                        name: 'register'
                    })
                })
            }
        }
        return {
            // terms
            terms,
            acceptedTerms,
            termClick,
            // vatin
            vatinStatus,
            vatinCheck,
            // register
            contact,
            company,
            handleSubmit,
            registerStatus,
            // info sources
            infoSources,
            selectedInfoSource
        }
    }
}
</script>
